import { Typography } from '@material-ui/core';
import PageContainer from '../../components/PageContainer';
import TopBar from '../../components/TopBar';
import { useStyles } from './styles';
import BottomBar from '../../components/BottomBar';
import waveBottomImg from '../../assets/wave2.png';
import Subdivision from '../../components/Subdivision';
import MenuLink from '../../components/MenuLink';
import { useEffect } from 'react';
import { useTheme } from '../../hooks/useTheme';

function Legislation() {
  const classes = useStyles();
  const { changeTheme } = useTheme();
  useEffect(() => {
    changeTheme();
  }, [])
  return(
    <>
      <TopBar>
        <Typography variant="h1">
          Legislação e Direitos
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography variant="body1" color="textPrimary">
            Aqui você tem acesso a links sobre Legislações e Direitos relacionados a pessoa idosa.
          </Typography>
          <div className={classes.container}>
            <MenuLink href="https://www2.senado.leg.br/bdsf/bitstream/handle/id/530232/estatuto_do_idoso_1ed.pdf">
              Estatuto do Idoso
            </MenuLink>
            <Subdivision title="•	Cidade de São Paulo"/>

            <MenuLink href="http://legislacao.prefeitura.sp.gov.br/leis/lei-15679-de-21-de-dezembro-de-2012">
              Fundo Municipal do Idoso (FMID) - Lei Municipal nº 15.679, de 21/12/2012
            </MenuLink>
            <MenuLink href="http://legislacao.prefeitura.sp.gov.br/leis/decreto-57906-de-01-de-outubro-de-2017">
              Regulamentação por meio do Decreto nº 57.906
            </MenuLink>
            <MenuLink href="https://www.prefeitura.sp.gov.br/cidade/secretarias/upload/criacao%20gci.pdf">
              Lei nº 11.242, de 24 de setembro de 1992, cria o Grande Conselho Municipal do Idoso (GCMI)
            </MenuLink>
            <MenuLink href="https://www.prefeitura.sp.gov.br/cidade/secretarias/upload/Regimento%20Interno%202016.pdf">
              Regimento Interno do GCMI
            </MenuLink>
            <MenuLink href="https://www.prefeitura.sp.gov.br/cidade/secretarias/direitos_humanos/participacao_social/conselhos_e_orgaos_colegiados/gcmi/index.php?p=165711">
              Estrutura do Grande Conselho Municipal do Idoso (GCMI) – Quem é quem (2021)
            </MenuLink>
            <MenuLink href="https://www.prefeitura.sp.gov.br/cidade/secretarias/direitos_humanos/idosos/legislacao/index.php?p=11062">
              Lei Municipal do Idoso – Lei nº 13.834, de 27/05/2004
            </MenuLink>
            <MenuLink href="https://www.prefeitura.sp.gov.br/cidade/secretarias/direitos_humanos/participacao_social/fundos/fumcad/fundo_municipal_do_idoso/index.php?p=269579">
              Resoluções, decretos, portarias e demais normativas referentes à participação social da pessoa idosa na cidade de São Paulo
            </MenuLink>
            <MenuLink href="https://www.prefeitura.sp.gov.br/cidade/secretarias/upload/direitos_humanos/participacao_social/CONFERENCIAS/IDOSO2019/RELATORIO_FINAL_SEM_SANGRIA.pdf">
              V Conferência Municipal dos Direitos da Pessoa Idosa – Relatório Final
            </MenuLink>
            <MenuLink href="https://www.desenvolvimentosocial.sp.gov.br/wp-content/uploads/2021/06/sp-amigo-3.pdf">
              Guia de Orientações Técnicas para a obtenção do Selo Município Amigo do Idoso
            </MenuLink>
            <Subdivision title="•	Estado de São Paulo"/>
            <MenuLink href="https://www.al.sp.gov.br/repositorio/legislacao/lei/2007/lei-12548-27.02.2007.html">
              Lei nº 12.548, de 27 de fevereiro de 2007, cria Fundo Estadual do Idoso por meio da Consolidação da Legislação Relativa ao Idoso
            </MenuLink>
            <MenuLink href="https://www.desenvolvimentosocial.sp.gov.br/wp-content/uploads/2021/06/fei.pdf">
              Regulamento do Fundo Estadual do Idoso
            </MenuLink>
            <MenuLink href="https://www.desenvolvimentosocial.sp.gov.br/wp-content/uploads/2021/05/estatutodoidoso-cei-2021.pdf">
              Estatuto do Idoso (edição 2021 do Governo do Estado de São Paulo) – contém Legislação Relativa ao Idoso e Regulamento do Fundo Estadual do Idoso
            </MenuLink>
            <MenuLink href="https://www.desenvolvimentosocial.sp.gov.br/wp-content/uploads/2020/07/anais-xv-conferncia-estadual-do-idoso-sp.pdf">
              Anais da XV Conferência Estadual do Idoso
            </MenuLink>
            <Subdivision title="•	Nacional/ Federal"/>
            
            <MenuLink href="https://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Normativas/politica_idoso.pdf">
              Política Nacional do Idoso
            </MenuLink>
            <MenuLink href="https://www.in.gov.br/web/dou/-/decreto-n-9.893-de-27-de-junho-de-2019-179414698">
              DECRETO Nº 9.893, de 27 DE JUNHO DE 2019, dispõe sobre o Conselho Nacional do Direitos da Pessoa Idosa
            </MenuLink>
            <MenuLink href="https://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Normativas/LoasAnotada.pdf">
              Lei Orgânica de Assistência Social. Institui o Benefício de Prestação Continuada (BPC)
            </MenuLink>
            <MenuLink href="https://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Normativas/PNAS2004.pdf">
              Política Nacional de Assistência Social (PNAS)
            </MenuLink>
            <MenuLink href="https://www.ipea.gov.br/participacao/images/pdfs/conferencias/Idosos/regulamento_relatorio_1_conferencia_direitos_pessoa_idosa.pdf">
              Anais da I Conferência Nacional dos Direitos da Pessoa Idosa
            </MenuLink>
            <MenuLink href="https://www.ipea.gov.br/participacao/images/pdfs/conferencias/Idosos_II/relatorio_regimento_regulamento_deliberacoes_2_conferencia_direitos_pessoa_idosa.pdf">
              Anais da II Conferência Nacional dos Direitos da Pessoa Idosa
            </MenuLink>
            <MenuLink href="https://bibliotecadigital.mdh.gov.br/jspui/handle/192/1415">
              Conferências Nacionais - Pessoa Idosa
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Normativas/tipificacao.pdf">
              Tipificação Nacional de Serviços Socioassistenciais
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/assistencia_social/caderno_PSB_idoso_pcd_1.pdf">
              Proteção Social Básica no Domicílio para Pessoas com Deficiência e Idosas
            </MenuLink>
            <MenuLink href="http://www.mpsp.mp.br/portal/page/portal/CAO_Idoso/Textos/Conven%C3%A7%C3%A3o%20Interamericana.pdf">
              Convenção Interamericana sobre a Proteção dos Direitos Humanos dos Idosos
            </MenuLink>
            <Subdivision title="•	Guias e cartilhas"/>
            
            <MenuLink href="https://www.desenvolvimentosocial.sp.gov.br/a2sitebox/arquivos/documentos/658.pdf">
              Guia de Orientações Técnicas Centro Dia do Idoso – SDS
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Cadernos/concepcao_fortalecimento_vinculos.pdf">
              Concepção de Convivência e Fortalecimento de Vínculos
            </MenuLink>
            <MenuLink href="https://www.gov.br/mdh/pt-br/assuntos/noticias/2020-2/junho/cartilhacombateviolenciapessoaidosa.pdf">
              Violência contra a Pessoa Idosa – Cartilha: onde denunciar e pedir ajuda
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/cartilhas/cartilha-bpc-final.pdf">
              Cartilha - Benefício de Prestação Continuada da Assistência Social – BPC
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/cartilhas/Manual_informativoSuas.pdf">
              SUAS – Manual informativo para jornalistas, gestores e técnicos
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Cadernos/Cartilha_PAIF_1605.pdf">
              Caderno de orientações - Serviço de Proteção e Atendimento Integral à Família e Serviço de Convivência e Fortalecimento de Vínculos. Articulação necessária na Proteção Social Básica
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Cadernos/2019/Curso%20de%20Prote%C3%A7%C3%A3o%20social%20no%20SUAS.pdf">
              Proteção social no SUAS a indivíduos e famílias em situação de violência e outras violações de direitos: fortalecimento da rede socioassistencial
            </MenuLink>
          </div>
        </div>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={waveBottomImg} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  );
}

export default Legislation;